import { down, up } from 'styled-breakpoints'
import styled from 'styled-components'

export const WhyChooseRegisterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f2f9ff;
  padding: 60px 0px;
  margin-bottom: 60px;
  @media screen and (max-width: 962px) {
    height: auto;
  }
  ${down('md')} {
    padding: 32px 0px;
    margin-bottom: 32px;
  }
`

export const Content = styled.div`
  ${up('md')} {
    margin: 0 auto;
    width: 1120px;
    max-width: 100%;
  }

  ${down('md')} {
    margin: 0 auto;
    max-width: 93%;
  }

  ${up('lg')} {
    max-width: 98%;
    margin: 0 auto;
  }
`

export const WhyChooseRegisterHeading = styled.h2`
  color: #131717;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  margin: 0px 0px 24px 0px;
  @media screen and (max-width: 962px) {
    margin: 0px 0px 16px 0px;
    font-size: 20px;
    font-weight: 600;
  }
`

export const WhyChooseRegisterCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  justify-content: start;
  height: 98%;
  gap: 24px;
  padding: 24px;
  width: 100%;
  border: 1px solid transparent;
  background: #ffffff;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.04), 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  margin: 0;
  transition-duration: 0.2s;
  transition-property: border, box-shadow;

  [dir='rtl'] && {
    text-align: right;
    direction: rtl;
  }

  &:hover {
    border-radius: 8px;
    background: var(--greys-white, #fff);
    box-shadow: 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
`

export const WhyChooseRegisterCardHeading = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #131717;
  margin-bottom: 4px;
`

export const WhyChooseRegisterCardText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #131717;
`

export const WhyChooseRegisterButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  width: 100%;
`

export const WhyChooseRegisterButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  [dir='rtl'] && {
    direction: rtl;

    svg {
      transform: scaleX(-1);
    }
  }
`
